module.exports = "/static/media/lineto-circular-boldItalic.df71ef45.eot";